var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowCoolDownGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 84,
    viewBox: "0 0 58 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9998 83.3223L0.0742188 54.3966L5.85934 48.5082L24.8676 67.5165V37.8677H33.1321V67.5165L52.1403 48.6115L57.9255 54.3966L28.9998 83.3223ZM24.8676 29.6032V17.2065H33.1321V29.6032H24.8676ZM24.8676 8.94208V0.677612H33.1321V8.94208H24.8676Z",
    fill: "#CECECE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCoolDownGray);
export default __webpack_public_path__ + "static/media/arrow_cool_down_gray.661f1eb4a9d39b983607c9435d1d62a7.svg";
export { ForwardRef as ReactComponent };